import { num } from "@/lib/api";

const YEARS = Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - i);

export const PeriodPicker = ({ period, setPeriod }) => {
  const setYear = (y) => setPeriod({ mode: "anio", desde: `${y}-01-01`, hasta: `${y}-12-31` });
  const tab = (m, label) => (
    <button onClick={() => (m === "anio" ? setYear(YEARS[0]) : setPeriod({ ...period, mode: "rango" }))} data-testid={`gri-period-${m}`}
      className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${period.mode === m ? "bg-[#05130e] text-white" : "text-slate-600 hover:bg-slate-100"}`}>{label}</button>
  );
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="gri-period-picker">
      <div className="flex bg-white border border-slate-200 rounded-full p-1">{tab("anio", "Año calendario")}{tab("rango", "Rango de fechas")}</div>
      {period.mode === "anio" ? (
        <select value={period.desde.slice(0, 4)} onChange={(e) => setYear(e.target.value)} className="h-10 rounded-full border border-slate-200 bg-white px-4 text-sm" data-testid="gri-year-select">
          {YEARS.map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
      ) : (
        <div className="flex items-center gap-2 text-sm">
          <input type="date" value={period.desde} onChange={(e) => setPeriod({ ...period, desde: e.target.value })} className="h-10 rounded-full border border-slate-200 bg-white px-3" data-testid="gri-date-from" />
          <span className="text-slate-400">a</span>
          <input type="date" value={period.hasta} onChange={(e) => setPeriod({ ...period, hasta: e.target.value })} className="h-10 rounded-full border border-slate-200 bg-white px-3" data-testid="gri-date-to" />
        </div>
      )}
    </div>
  );
};

export const KpiCards = ({ rep }) => {
  const cards = [
    ["306-3", "Residuos generados", `${num(rep.gri306_3.total_t, 3)} t`, "kpi-306-3"],
    ["306-4", "Desviados de la eliminación", `${num(rep.gri306_4.total_t, 3)} t`, "kpi-306-4"],
    ["306-5", "Dirigidos a eliminación", `${num(rep.gri306_5.total_t, 3)} t`, "kpi-306-5"],
  ];
  return (
    <section className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="gri-kpis">
      {cards.map(([code, label, value, tid]) => (
        <div key={code} className="bg-white border border-slate-200 rounded-3xl p-5">
          <p className="font-mono text-[11px] uppercase tracking-widest text-[#00915f]">GRI {code}</p>
          <p className="text-2xl font-bold text-[#05130e] mt-2" data-testid={tid}>{value}</p>
          <p className="text-xs text-slate-500 mt-1">{label}</p>
        </div>
      ))}
      <div className="bg-[#0a1f18] text-white rounded-3xl p-5">
        <p className="font-mono text-[11px] uppercase tracking-widest text-[#00f2a1]">Tasa de Desviación Circular</p>
        <p className="text-3xl font-bold mt-2" data-testid="kpi-diversion-rate">{rep.tasa_desviacion == null ? "—" : `${num(rep.tasa_desviacion, 1)}%`}</p>
        <div className="h-1.5 bg-white/10 rounded-full mt-3 overflow-hidden"><div className="h-full bg-[#00f2a1] transition-[width] duration-700" style={{ width: `${rep.tasa_desviacion || 0}%` }} /></div>
        <p className="text-[11px] text-slate-400 mt-2">Meta: Zero Waste to Landfill · {num(rep.en_gestion_t, 3)} t en gestión</p>
      </div>
    </section>
  );
};

export const GriTable = ({ cols, rows, testid }) => (
  <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white" data-testid={testid}>
    <table className="w-full text-sm">
      <thead className="bg-[#00f2a1]/10 text-left text-xs uppercase tracking-wide text-[#007a50]">
        <tr>{cols.map((c) => <th key={c} className="px-4 py-2.5 font-semibold whitespace-nowrap">{c}</th>)}</tr>
      </thead>
      <tbody>
        {rows.length === 0 && <tr><td colSpan={cols.length} className="px-4 py-4 text-slate-400">Sin registros en el periodo</td></tr>}
        {rows.map((r, i) => (
          <tr key={i} className="border-t border-slate-100">{r.map((v, j) => <td key={j} className={`px-4 py-2.5 text-slate-700 align-top ${j === 0 || String(v ?? "").length < 22 ? "whitespace-nowrap" : ""}`}>{v ?? "—"}</td>)}</tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const Block = ({ code, title, desc, children, testid }) => (
  <section className="space-y-3" data-testid={testid}>
    <div>
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00b37a]">GRI {code}</p>
      <h2 className="text-lg font-semibold text-[#05130e]">{title}</h2>
      {desc && <p className="text-sm text-slate-500">{desc}</p>}
    </div>
    {children}
  </section>
);
